export default __webpack_public_path__ + "static/media/close.1e057fde.svg";